import Notification from "@/services/echo-manager/notification";
import {useMainStore} from "@/store";

export default class CharacterPointsUpdated extends Notification
{
    handle() {
        useMainStore().UPDATE_CHARACTER_POINTS(this.message.data);
    }
}
